<template>
  <div class="filter">
    <img src="/Cartago_Logo_0222_weiß.png">
      <p class="name">HTML Creator</p>
      <br>
    <!-- Obere Section: Button für Filesystem-Aufruf -->
    <div class="top-section">
      <ul>
        <li @click="openFileSystem('FS')" :class="{ active: view === 'FS' }">
          <div class="routerElement">
          <span class="material-symbols-outlined">note_add</span>
          <span>{{ $t('Filter.Template') }}</span>
        </div>
        </li>
        <li @click="openFileSystem('Edit')" :class="{ active: view === 'Edit' }">
          <div class="routerElement">
          <span class="material-symbols-outlined">edit</span>
          <span>{{ $t('Filter.Editor') }}</span>
        </div>
        </li>
        <li @click="openFileSystem('Preview')" :class="{ active: view === 'Preview' }">
          <div class="routerElement">
          <span class="material-symbols-outlined">preview</span>
          <span>{{ $t('Filter.Preview') }}</span>
        </div>
        </li>
        <li @click="openFileSystem('HTML')" :class="{ active: view === 'HTML' }">
          <div class="routerElement">
          <span class="material-symbols-outlined">code</span>
          <span>HTML</span>
        </div>
        </li>
        <li @click="openFileSystem('Rulesets')" :class="{ active: view === 'Rulesets' }">
          <div class="routerElement">
          <span class="material-symbols-outlined">account_tree</span>
          <span>{{ $t('Filter.BlockOverview') }}</span>
        </div>
        </li>
        <li @click="openFileSystem('Mapping')" :class="{ active: view === 'Mapping' }">
          <div class="routerElement">
          <span class="material-symbols-outlined">bolt</span>
          <span>{{ $t('Filter.Mapping') }}</span>
        </div>
        </li>
      </ul>
    </div>
    <div class="section">
      <DbEmails v-if= "view !== 'FS'" @load-email="getDbMails" />
    </div>
  </div>
</template>

<script setup>
import { computed} from 'vue'
import {useStore} from 'vuex'
import DbEmails from './Reusables/DbEmails.vue';

const store = useStore();
const view = computed(()=>store.state.view)


function openFileSystem(vp) {
  console.log("File System Button wurde geklickt", vp)
  store.dispatch("updateView", vp)
}

</script>

<style scoped>
.filter {
  padding: 20px;
  background: #2c3e50;
  height: 100vh;
  font-family: 'Montserrat', sans-serif;
  color: white;
  max-width: 100%;
}

/* Top Section */
.top-section {
  margin-bottom: 50px;
  text-align: center;
}

.material-symbols-outlined {
  font-size: 20px;
}

img {
    width: 90%;
    padding: 10px;
    border-bottom: 1px solid white;
  }

  .name {
    margin-top: 2px;
    font-family: "Montserrat", sans-serif;
    font-size: 13px;
    text-align: center !important;
    color: white;
  }

ul {
  list-style: none;
  padding: 0;
}

li {
display: block; /* Stellt sicher, dass der gesamte Bereich klickbar ist */
padding: 10px; /* Sorgt für den Abstand */
color: white;
text-decoration: none;

}

li:hover{
  background-color: #273646;
  cursor: pointer;
}

.active{
  background-color: #273646;
}


.routerElement {
display: flex; /* Für eine horizontale Anordnung der Icons und Texte */
align-items: center;
gap: 10px; /* Abstand zwischen Icon und Text */
padding: 3px; /* Innenabstand für den Inhalt */
}

.section{
  max-width: 100%
}
</style>

 